import { useState } from 'react'
import {
  SortCommunityCommentsEnum,
  SortProfileCommunityPostsEnum
} from '../../../../../../../../__generated__/graphql'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import Popover from './Popover'
import classNames from 'classnames'
import styles from './_communitySortDropdown.module.scss'
import { t } from '../../../../../../../../utils'

type PostsOrCommentsSortEnum =
  | SortCommunityCommentsEnum
  | SortProfileCommunityPostsEnum

const CommunitySortDropdown: React.FC<{
  options: {
    label: string
    value: PostsOrCommentsSortEnum
  }[]
  activeValue: PostsOrCommentsSortEnum
  onSelect: (option: PostsOrCommentsSortEnum) => void
}> = ({ options, activeValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false)

  const activeLabel = options.find(
    (option) => option.value === activeValue
  )?.label

  return (
    <div className={styles.sortDropdown}>
      {t('Sort by:')}

      <button onClick={() => setIsOpen((isOpen) => !isOpen)}>
        {activeLabel}
        {isOpen ? (
          <FontAwesomeIcon color="#9a9a9a" icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon color="#9a9a9a" icon={faChevronDown} />
        )}
      </button>

      {isOpen && (
        <Popover style={styles.dropdownOptionsContainer}>
          {options.map((option) => {
            const isActive = option.value === activeValue
            return (
              <div
                key={option.value}
                onClick={() => {
                  onSelect(option.value)
                  setIsOpen(false)
                }}
                className={classNames(styles.sortDropdownOption, {
                  [styles.sortDropdownOptionActive]: isActive
                })}
              >
                {option.label}
              </div>
            )
          })}
        </Popover>
      )}
    </div>
  )
}

export default CommunitySortDropdown
